var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgLinkedIn(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#007EBB",
    d: "M24 24h-3.536v-5.273c0-1.38-.553-2.323-1.77-2.323-.93 0-1.448.636-1.688 1.25-.09.219-.077.525-.077.832V24h-3.503s.045-9.34 0-10.19h3.503v1.6c.207-.7 1.327-1.698 3.113-1.698 2.217 0 3.958 1.466 3.958 4.622V24zM9.883 12.536h-.022c-1.13 0-1.861-.78-1.861-1.767C8 9.763 8.754 9 9.905 9c1.15 0 1.858.76 1.88 1.766 0 .988-.73 1.77-1.902 1.77zm-1.48 1.274h3.12V24h-3.12V13.81z"
  }));
}

export default SvgLinkedIn;